import React from 'react';

// Shared summary-card building blocks (user and admin UIs).
//
// StatTile: static KPI tile — label on top, big value below.
// StatusCard: clickable filter card — label + value left, icon right,
// highlighted ring when its filter is active.

export function StatTile({ label, value, sub }: { label: string; value: React.ReactNode; sub?: string }) {
  return (
    <div className="bg-widget-bg rounded-lg border border-gray-700 px-4 py-2.5">
      <div className="text-xs text-secondary">{label}</div>
      <div className="text-xl font-bold text-heading">{value}</div>
      {sub && <div className="text-xs text-secondary mt-1">{sub}</div>}
    </div>
  );
}

export function StatusCard({
  label,
  value,
  icon: Icon,
  iconClass,
  active,
  // Border/ring classes applied when active, e.g. 'border-primary ring-2 ring-primary/50'.
  activeClass,
  onClick,
}: {
  label: string;
  value: React.ReactNode;
  icon: React.ComponentType<{ className?: string }>;
  iconClass: string;
  active: boolean;
  activeClass: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={`bg-widget-bg rounded-lg p-4 border cursor-pointer text-left transition-all hover:scale-105 ${
        active ? activeClass : 'border-secondary'
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-secondary text-xs">{label}</p>
          <p className="text-xl font-bold text-heading">{value}</p>
        </div>
        <Icon className={`w-6 h-6 shrink-0 ${iconClass}`} />
      </div>
    </button>
  );
}
